import { useState, useRef, useEffect } from 'react';
import { DisclaimerWrapper, DisclaimerLink, DisclaimerTooltip } from './PageHeader.styles';

interface DisclaimerPopupProps {
    children: React.ReactNode;
}

const DisclaimerPopup = ({ children }: DisclaimerPopupProps): JSX.Element => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return;
        const handleClickOutside = (e: MouseEvent): void => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    return (
        <DisclaimerWrapper ref={wrapperRef}>
            <DisclaimerLink onClick={() => setOpen(prev => !prev)}>Disclaimer and terms of use</DisclaimerLink>
            <DisclaimerTooltip $visible={open}>
                {children}
            </DisclaimerTooltip>
        </DisclaimerWrapper>
    );
};

export default DisclaimerPopup;
